import React from 'react';

import {
  DrawerCloseButton as ChakraDrawerCloseButton,
  forwardRef,
  useStyleConfig,
} from '@chakra-ui/react';

import { CloseIcon } from '../../icons';
import { DrawerCloseButtonProps } from './types';

export const DrawerCloseButton = forwardRef<DrawerCloseButtonProps, 'button'>(
  (props, ref) => {
    const styles = useStyleConfig('DrawerCloseButton', { ...props });
    return (
      <ChakraDrawerCloseButton ref={ref} sx={styles} {...props}>
        <CloseIcon />
      </ChakraDrawerCloseButton>
    );
  }
);
